import { SVGProps } from "react"

type Props = SVGProps<SVGSVGElement> & {
  size?: number
  color?: string
}

export const IconDrawerClose = ({
  size = 24,
  color = "black",
  ...props
}: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 7C0.447715 7 0 7.44772 0 8C0 8.55228 0.447715 9 1 9L1 7ZM16.7071 8.70711C17.0976 8.31658 17.0976 7.68342 16.7071 7.29289L10.3431 0.928932C9.95262 0.538408 9.31946 0.538408 8.92893 0.928932C8.53841 1.31946 8.53841 1.95262 8.92893 2.34315L14.5858 8L8.92893 13.6569C8.53841 14.0474 8.53841 14.6805 8.92893 15.0711C9.31946 15.4616 9.95262 15.4616 10.3431 15.0711L16.7071 8.70711ZM1 9L16 9V7L1 7L1 9Z"
      fill={color}
    />
    <path d="M19 2V14" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
)
